<template>
  <v-container xs12 fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r shadow-1  mb-2">
      <v-toolbar class="primary hidden-xs-only darken-2 card-r hidden-sm-only pl-3 text-white">
        <v-layout row wrap>
          <v-flex lg3 class="mt-2">
            <div class="text-xs-left f-20 pt-2">Calender {{selectedFilter}}</div>
          </v-flex>
            <v-flex lg5 class="text-lg-center pa-0 pt-2 mt-1 hide-pro pro">
            <div class="t-radio text-lg-center white redius-5 pt-0 mt-1 pb-1 px-2">
              <v-radio-group v-model="selectedFilter" row class="text-white">
                <v-radio label="All" value="all" color="primary"></v-radio>
                <v-radio label="Teachers" value="Teachers" class="pa-0 ma-0" color="primary"></v-radio>
                <v-radio label="Classes" value="Classes" class="pa-0 ma-0" color="primary"></v-radio>
                <v-radio label="Locations" value="Locations" class="pa-0 ma-0" color="primary"></v-radio>
              </v-radio-group>
            </div>
          </v-flex>
          <v-flex lg4 class="pa-0">
            <div class="text-xs-right pa-2">
              <v-flex xs12 class="pro">
                <v-select
                  dark
                  solo
                  v-model="selectedOption"
                  background-color="white"
                  class="text-grey f-12 pt-2"
                  :items="selectList"
                  :disabled="selectedFilter=='all'"
                  item-text="name"
                  item-value="id"
                  :label="selectListLabel"
                  @change="loadCalendarEvents"
                ></v-select>
                <!-- {{selectList}} -->
              </v-flex>
            </div>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <!-- <v-layout row wrap class="hidden-lg-only hidden-md-only ">
        <v-flex lg3 xs12 class="pa-0 pl-2">
          <div class="text-xs-left f-20">Calender </div>
        </v-flex>
        <v-flex lg5 xs12 class="text-lg-center pa-0 hide-pro pro">
          <div class="t-radio text-lg-center white redius-5 pt-0 pb-1 px-2">
            <p>{{ selectedFilter || 'null' }}</p>
        <v-radio-group v-model="selectedFilter" :mandatory="false">
          <v-radio label="Radio 1" value="radio-1"></v-radio>
          <v-radio label="Radio 2" value="radio-2"></v-radio>
        </v-radio-group>
            <v-radio-group v-model="selectedFilter" row class="text-white">
              <v-radio label="All" value="all" color="primary"></v-radio>
              <v-radio label="Teachers" value="Teachers" class="pa-0 ma-0" color="primary"></v-radio>
              <v-radio label="Classes" value="Classes" class="pa-0 ma-0" color="primary"></v-radio>
              <v-radio label="Locations" value="Locations" class="pa-0 ma-0" color="primary"></v-radio>
            </v-radio-group>
          </div>
        </v-flex>
        <v-flex lg4 xs12 class="pa-0">
          <div class="text-xs-right pa-2">
            <v-flex xs12 class="pro hide-pro">
              <v-select
                dark
                solo
                background-color="white"
                class="text-grey f-12 pt-2"
                :items="selectList"
                label="Select"
              ></v-select>
            </v-flex>
          </div>
        </v-flex>
      </v-layout> -->
    </v-card>
    <!-- <v-container fluid grid-list-xl class="pt-0">
      <v-layout xs12> -->
        <!-- <v-flex xs6 offset-xs0 class="">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="Start Date"
              persistent-hint
              placeholder="dd/mm/yyyy"
              prepend-icon="event"
            ></v-text-field>
            <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6 offset-xs0 class="">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormatted"
              label="End Date"
              persistent-hint
              placeholder="dd/mm/yyyy"
              prepend-icon="event"
            ></v-text-field>
            <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-flex> -->
      <!-- </v-layout> -->
      <!--<v-layout xs12>-->
      <!--<v-flex  offset-xs0 class="ml-3 mr-2 pa-0 pl-5">-->
      <!--<v-autocomplete-->
      <!--v-model="model"-->
      <!--:items="searchname"-->
      <!--label="Search Name"-->
      <!--placeholder="Name ">-->
      <!--</v-autocomplete>-->
      <!--</v-flex>-->

      <!--&lt;!&ndash;<v-divider inset vertical></v-divider>&ndash;&gt;-->

      <!--<v-flex offset-xs0 class="ml-3 mr-2 pa-0 pr-5">-->
      <!--<v-autocomplete-->
      <!--v-model="model"-->
      <!--:items="city"-->
      <!--label="Select Address"-->
      <!--placeholder="Address ">-->
      <!--</v-autocomplete>-->
      <!--</v-flex>-->
      <!--</v-layout>-->
    <!-- </v-container> -->

    <v-dialog
      v-model="dialog"
      max-width="525">
      <v-card v-if="selectedEvent" class="pt-2 grey lighten-4">

        <v-btn class="right primary" icon>
          <v-icon class="text-white left" @click="dialog=false,dialogEditEvent=true,eventCreateErrorMsg='',eventCreationSuccessMsg='',loadEventDays()">edit</v-icon>
        </v-btn>
        <v-btn class="right primary" icon>
          <v-icon class="text-white left" @click="showDeletePopup(selectedEvent.id)">delete</v-icon>
        </v-btn>

        <v-card-title class="headline pb-0">{{ selectedEvent.title }} ( {{ selectedEvent.time_from }} )</v-card-title>
        <v-card-title class="grey--text pt-0 font-weight-bold f-12">{{ selectedEvent.description }}</v-card-title>

        <!--<v-card-text>-->
        <!--Event Start At: {{ selectedEvent.start }}-->
        <!--</v-card-text>-->
        <!--<v-card-text>-->
        <!--Event End At: {{ selectedEvent.end }}-->
        <!--</v-card-text>-->
        <v-container fluid grid-list-xl class="pt-0 pb-0">
          <span class="f-15 textColor font-weight-bold">Classes Details</span>
          <v-layout row wrap class="">
            <v-flex d-flex lg12 sm12 xs12 class=" ">
              <div>
                <span class="f-12 font-weight-bold mr-3 ">Class Title:</span> {{ selectedEvent.title }}
              </div>
            </v-flex>
            <v-flex d-flex lg12 sm12 xs12 class=" ">
              <div>
                <span class="f-12 font-weight-bold mr-3 ">Class Location:</span> {{ selectedEvent.class_location }}
              </div>
            </v-flex>
            <v-flex d-flex lg12 sm12 xs12 class=" ">
              <div>
                <span class="f-12 font-weight-bold mr-3 ">Number Of Students:</span> {{ selectedEvent.number_of_students }}
              </div>
            </v-flex>
            <v-flex d-flex lg12 sm12 xs12 class=" ">
              <div>
                <span class="f-12 font-weight-bold mr-3 ">Start Time:</span> {{ selectedEvent.time_from }}
              </div>
            </v-flex>
            <v-flex d-flex lg12 sm12 xs12 class=" ">
              <div>
                <span class="f-12 font-weight-bold mr-3 ">Minutes:</span> {{ selectedEvent.hours }}
              </div>
            </v-flex>
          </v-layout>
          <span class="f-15 textColor font-weight-bold">Teacher Details</span>
          <v-layout row wrap class="">
            <v-flex d-flex lg12 sm12 xs12 class=" ">
              <div>
                <span class="f-12 font-weight-bold mr-3 ">Name:</span> {{ selectedEvent.teacherName }}
              </div>
            </v-flex>
            <v-flex d-flex lg12 sm12 xs12 class=" ">
              <div>
                <span class="f-12 font-weight-bold mr-3 ">Phone Number:</span> +45 {{ selectedEvent.teacherPhone }}
              </div>
            </v-flex>
            <v-flex d-flex lg12 sm12 xs12 class=" ">
              <div>
                <span class="f-12 font-weight-bold mr-3 ">Email:</span> {{ selectedEvent.teacherMail }}
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="secondory"
            outline
            @click="dialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deletePopup"
      max-width="525">
      <!-- deleteEvent(selectedEvent.id) -->
      <v-card class="card-pop card-r no-shadow pa-3 grey lighten-4">
        <div  class="pt-3 mt-5 text-xs-center">
         <span class="f-20">
            Do you confirm?
         </span>
        </div>
        <v-layout wrap row>
          <v-flex xs12 class="pt-2">
            <v-list>
              <v-radio-group class="w-100" v-model="selectedDeleteOption">

                <v-card color="grey lighten-2" class="mt-2 pt-3 pa-2 mb-2 card-r no-shadow">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-radio
                        label="Delete All Events"
                        value="all"
                      ></v-radio>
                    </v-list-tile-action>

                  </v-list-tile>
                </v-card>
                <v-card color="grey lighten-2" class="pt-3 pa-2 card-r no-shadow">
                  <v-list-tile>
                    <!-- <v-list-tile-action> -->
                    <v-radio
                      :label="'Delete '+selectedEvent.start+' Event Only'"
                      value="single"
                    ></v-radio>
                    <!-- </v-list-tile-action> -->

                  </v-list-tile>
                </v-card>
              </v-radio-group>

            </v-list>
            <!--<v-flex md12 sm12 xs12 class=" checkbox  mt-2">-->
            <!--<v-checkbox-->
            <!--v-model="policy"-->
            <!--label="Same The Profile Info"-->
            <!--class="input-group&#45;&#45;focused f-20 pa-0 ma-0"-->
            <!--color="primary"-->
            <!--required-->
            <!--&gt;</v-checkbox>-->
            <!--</v-flex>-->
          </v-flex>
        </v-layout>
        <v-layout xs12>
          <v-flex xs12 class="text-xs-left mr-1">
            <v-btn @click="deletePopup = false" color="grey lighten-2" class="btn-customer no-shadow h-50p card-r">Cancel</v-btn>
          </v-flex>
          <v-flex xs12 class="text-xs-right ml-1">
            <v-btn @click="deleteEvent(selectedDeleteEventId), dialog = false" class="btn-customer card-r h-50p primary text-white no-shadow card-r">Confirm</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- creating new event -->
    <v-dialog
      v-model="dialogCreateEvent"
      max-width="525">
      <v-card class="pb-3 grey lighten-4 card-r" v-if="dialogCreateEvent">
        <v-card-title class="headline ml-2">Create Class</v-card-title>

        <v-container fluid grid-list-xl class="pt-1 pb-0">
          <span class="f-15 textColor font-weight-bold">Class Details</span>

          <v-layout row wrap class="">
            <!--<v-flex d-flex lg6 sm6 xs12 class="pt-0 pb-0">-->
            <!--<v-autocomplete-->
            <!--v-model="classtype"-->
            <!--:items="whats_app"-->
            <!--label="Class Type"-->
            <!--placeholder="select Class type">-->
            <!--</v-autocomplete>-->
            <!--</v-flex>-->
            <v-flex d-flex lg6 sm12 xs12 class="pt-0 pb-0 pt-1">
              <v-autocomplete solo
                              v-model="selectedClass"
                              :items="ModulesList"
                              item-value="id"
                              item-text="name"
                              label="Class"
                              placeholder="Class">
              </v-autocomplete>
            </v-flex>
            <v-flex d-flex lg6 sm12 xs12 class="pt-0 pb-0 pt-1">
              <v-text-field solo
                              v-model="class_location"
                              item-value="id"
                              item-text="name"
                              label="Location"
                              placeholder="Location">
              </v-text-field>
            </v-flex>
            <v-flex d-flex lg6 sm6 xs12 class="pt-0 pb-0">
              <v-text-field
                solo
                v-model="noOfStudents"
                :items="n_student"
                label="Number Of Students"
                placeholder="Number of Students">
              </v-text-field>
            </v-flex>
            <v-flex d-flex lg6 sm6 xs12 class="pt-0 pb-0">
              <v-autocomplete
                solo
                v-model="selectedSlot"
                item-value="value"
                item-text="text"
                :items="timeslot"
                label="Start Time"
                placeholder="start time">
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <span class="f-15 textColor font-weight-bold">Teacher Details</span>
          <v-layout row wrap class="">
            <v-flex d-flex lg6 sm6 xs12 class="pt-0 pb-0">
              <v-select
                solo
                no-data-text
                :items="['Internal','External','Add New External']"
                v-model="teacherType"
                label="Teacher Type"
                placeholder="teacher Type">
              </v-select>
            </v-flex>
            <v-flex d-flex lg6 sm6 xs12 class="pt-0 pb-0">
              <!--<v-autocomplete-->
              <!--:items="teacher"-->
              <!--v-model="teachername"-->
              <!--label="Teacher name"-->
              <!--placeholder="select your type">-->
              <!--</v-autocomplete>   -->.
              <div v-if="teacherType=='Internal'">
                <v-autocomplete
                  no-data-text
                  solo
                  :items="InternalTeacherList"
                  v-model="SelectedInternalTeacher"
                  item-value="id"
                  item-text="name"
                  label="Teacher name"
                  placeholder="teacher name">
                </v-autocomplete>
              </div>
              <div v-if="teacherType=='External'">
                <v-autocomplete
                  no-data-text
                  solo
                  :items="ExternalTeacherList"
                  v-model="SelectedExternalTeacher"
                  item-value="id"
                  item-text="name"
                  label="Teacher name"
                  placeholder="teacher name">
                </v-autocomplete>
              </div>
              <div v-if="teacherType=='Add New External'">
                <v-flex d-flex lg12 sm12 xs12 class="pt-0 pb-0">
                  <v-text-field
                    solo
                    v-model="exTeacherName"
                    label="Teacher Name"
                    placeholder="Teacher Name">
                  </v-text-field>
                </v-flex>
                <v-flex d-flex lg12 sm12 xs12 class="pt-0 pb-0">
                  <v-text-field
                    solo
                    v-model="phonumber"
                    label="Phone number"
                    prefix="+45"
                    placeholder="phone number">
                  </v-text-field>
                </v-flex>
                <v-flex d-flex lg12 sm12 xs12 class="pt-0 pb-0">
                  <v-text-field
                    solo
                    label="Email"
                    v-model="emailad"
                    placeholder="email">
                  </v-text-field>
                </v-flex>
              </div>
            </v-flex>
          </v-layout>

          <span class="f-15 textColor font-weight-bold">Repeat Class</span>
          <v-layout row wrap class="mt-2">
            <v-flex lg12 sm12 xs12 class="pt-3 pb-0">
              <!--<v-select-->
              <!--:items="type"-->
              <!--solo-->
              <!--placeholder="Class Repete next weeks"-->
              <!--class=" mt-0 pt-0 pb-0"-->
              <!--v-model="Class.ClassType"-->
              <!--&gt;</v-select>-->
              <v-card-text class="pt-0 pb-0 pl-0">
                <!-- <v-radio-group class="pl-0 pt-0 mt-0" v-model="Class.ClassType" :items="type" row>
                  <v-radio
                    label="No Repete"
                    color="red"
                    value="NoRepete"/>
                  <v-radio
                    label="repeat the same schedule for upcoming days"
                    color="primary"
                    value="Repete"/>
                </v-radio-group> -->
              </v-card-text>
            </v-flex>
            <v-flex lg12 sm12 xs12 class="pt-0 pb-0">
              <v-card-text class="pt-0 pb-0">
                <v-layout row class="">
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0 check-label"
                              label="Mon"
                              color="red"
                              value="MON"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Tue"
                              color="red darken-3"
                              value="TUE"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Wed"
                              color="indigo"
                              value="WED"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Thu"
                              color="indigo darken-3"
                              value="THU"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Fri"
                              color="orange"
                              value="FRI"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Sat"
                              color="blue"
                              value="SAT"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Sun"
                              color="green"
                              value="SUN"
                              v-model="selectedDays"
                  ></v-checkbox>
                </v-layout>
              </v-card-text>
            </v-flex>
            <!-- <v-flex lg12 sm12 xs12 class="pt-0 pb-0" >
                <v-select
                    no-data-text
                    :items="['Every day','Every Week','Every Month','Every year']"
                    v-model="repeatType"
                    label="Repeat Type"
                    placeholder="Repeat Type">
                </v-select>
            </v-flex> -->
            <v-flex lg6 sm6 xs12 class="pt-0 pb-0" >
              <v-menu
                ref="dialog1"
                :close-on-content-click="false"
                v-model="birthday1"
                :return-value.sync="date1"
                lazy
                persistent
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="date1"
                  label="Start Date"
                  placeholder="dd/mm/yyyy"
                  solo
                  readonly
                  required
                ></v-text-field>
                <v-date-picker v-model="date1" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="birthday1 = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog1.save(date1)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex lg6 sm6 xs12 class="pt-0 pb-0">
              <v-menu
                ref="dialog"
                :close-on-content-click="false"
                v-model="birthday"
                :return-value.sync="date"
                lazy
                persistent
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="date"
                  label="End Date"
                  placeholder="dd/mm/yyyy"
                  solo
                  readonly
                  required
                ></v-text-field>
                <v-date-picker v-model="date" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="birthday = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>

        <!--<v-card-text>-->
        <!--<v-radio-group v-model="selectedEventClass" row>-->
        <!--<v-radio-->
        <!--label="Default"-->
        <!--color="blue"-->
        <!--value=""/>-->
        <!--<v-radio-->
        <!--label="Caution"-->
        <!--color="red"-->
        <!--value="event-item-caution"/>-->
        <!--<v-radio-->
        <!--label="Meeting"-->
        <!--color="green"-->
        <!--value="event-item-meeting"/>-->
        <!--<v-radio-->
        <!--label="Warning"-->
        <!--color="yellow"-->
        <!--value="event-item-warning"/>-->
        <!--<v-radio-->
        <!--label="Trip"-->
        <!--color="purple"-->
        <!--value="event-item-trip"/>-->
        <!--</v-radio-group>-->
        <!--</v-card-text>-->

        <v-card-actions class="mr-3">
          <v-spacer></v-spacer>

          <v-btn
            color="grey" class="card-r text-white"
            @click="dialogCreateEvent = false">
            cancel
          </v-btn>

          <v-btn
            color="primary" class="card-r text-white"
            @click="createEvent()">
            Submit
          </v-btn>
        </v-card-actions>
        <v-alert
          :value="true"
          type="error"
          v-if="eventCreateErrorMsg"
        >
          {{eventCreateErrorMsg}}
        </v-alert>
        <v-alert
          :value="true"
          type="success"
          v-if="eventCreationSuccessMsg"
        >
          {{eventCreationSuccessMsg}}
        </v-alert>

      </v-card>
    </v-dialog>

    <!-- EditEvent -->
    <v-dialog
      v-model="dialogEditEvent"
      max-width="525">
      <v-card class="pb-3 grey lighten-4" v-if="dialogEditEvent">
        <v-card-title class="headline ml-2">Edit Class</v-card-title>

        <v-container fluid grid-list-xl class="pt-0 pb-0">
          <span class="f-15 textColor font-weight-bold">Class Details</span>

          <v-layout row wrap class="">
            <!--<v-flex d-flex lg6 sm6 xs12 class="pt-0 pb-0">-->
            <!--<v-autocomplete-->
            <!--v-model="classtype"-->
            <!--:items="whats_app"-->
            <!--label="Class Type"-->
            <!--placeholder="select Class type">-->
            <!--</v-autocomplete>-->
            <!--</v-flex>-->
            <v-flex d-flex lg12 sm12 xs12 class="pt-0 pb-0">
              <v-autocomplete solo
                              v-model="selectedEvent.module_id"
                              :items="ModulesList"
                              item-value="id"
                              item-text="name"
                              label="Select class"
                              placeholder="select Class">
              </v-autocomplete>
            </v-flex>
            <v-layout row wrap class="">
            <v-flex d-flex lg12 sm12 xs12 class="pt-0 pb-0 ml-2 mr-2">
              <v-text-field
                v-model="selectedEvent.class_location"
                solo
                label="Location"
                placeholder="Location">
              </v-text-field>
            </v-flex>
            </v-layout>
            <v-layout row wrap class="">
            <v-flex lg6 sm5 xs6 class="pt-0 pb-0 ml-2">
              <v-text-field
                v-model="selectedEvent.number_of_students"
                solo
                label="Number Of Students"
                placeholder="select Number of Students">
              </v-text-field>
            </v-flex>
            <v-flex d-flex lg6 sm6 xs6 class="pt-0 pb-0 ml-2">
              <v-autocomplete
                solo
                v-model="selectedEvent.time_from"
                item-value="value"
                item-text="text"
                :items="timeslot1"
                label="Start Time"
                placeholder="select your start time">
              </v-autocomplete>
            </v-flex>
            </v-layout>
          </v-layout>
          <span class="f-15 textColor font-weight-bold mt-3">Teacher Details</span>
          <v-layout row wrap class="">
            <v-flex d-flex lg6 sm6 xs12 class="pt-0 pb-0">
              <v-select
                solo
                no-data-text
                :items="['Internal','External','Add New External']"
                v-model="selectedEvent.TeacherType"
                label="Teacher Type"
                placeholder="teacher Type">
              </v-select>
            </v-flex>
            <v-flex d-flex lg6 sm6 xs12 class="pt-0 pb-0">
              <!--<v-autocomplete-->
              <!--:items="teacher"-->
              <!--v-model="teachername"-->
              <!--label="Teacher name"-->
              <!--placeholder="select your type">-->
              <!--</v-autocomplete>   -->
              <div v-if="selectedEvent.TeacherType=='Internal'">
                <v-autocomplete
                  solo
                  :items="InternalTeacherList"
                  v-model="selectedEvent.teacherId"
                  item-value="id"
                  item-text="name"
                  label="Teacher name"
                  placeholder="teacher name">
                </v-autocomplete>
              </div>
              <div v-if="selectedEvent.TeacherType=='External'">
                <v-autocomplete
                  solo
                  :items="ExternalTeacherList"
                  v-model="selectedEvent.teacherId"
                  item-value="id"
                  item-text="name"
                  label="Teacher name"
                  placeholder="teacher name">
                </v-autocomplete>
              </div>
              <div v-if="selectedEvent.TeacherType=='Add New External'">
                <v-flex d-flex lg6 sm12 xs12 class="pt-0 pb-0">
                  <v-text-field
                    solo
                    v-model="selectedEvent.teacherName"
                    label="Teacher Name"
                    placeholder="Teacher Name">
                  </v-text-field>
                </v-flex>
                <v-flex d-flex lg6 sm12 xs12 class="pt-0 pb-0">
                  <v-text-field
                    solo
                    v-model="selectedEvent.teacherPhone"
                    label="Phone number"
                    prefix="+45"
                    placeholder="phone number">
                  </v-text-field>
                </v-flex>
                <v-flex d-flex lg12 sm12 xs12 class="pt-0 pb-0">
                  <v-text-field
                    solo
                    label="Email"
                    v-model="selectedEvent.teacherMail"
                    placeholder="email">
                  </v-text-field>
                </v-flex>
              </div>
            </v-flex>
          </v-layout>

          <span class="f-15 textColor font-weight-bold">Repeat Class</span>
          <v-layout row wrap class="mt-2">
            <v-flex lg12 sm12 xs12 class="pt-3 pb-0">
              <!--<v-select-->
              <!--:items="type"-->
              <!--solo-->
              <!--placeholder="Class Repete next weeks"-->
              <!--class=" mt-0 pt-0 pb-0"-->
              <!--v-model="Class.ClassType"-->
              <!--&gt;</v-select>-->
              <v-card-text class="pt-0 pb-0 pl-0">
                <!-- <v-radio-group class="pl-0 pt-0 mt-0" v-model="Class.ClassType" :items="type" row>
                  <v-radio
                    label="No Repete"
                    color="red"
                    value="NoRepete"/>
                  <v-radio
                    label="repeat the same schedule for upcoming days"
                    color="primary"
                    value="Repete"/>
                </v-radio-group> -->
              </v-card-text>
            </v-flex>
            <v-flex lg12 sm12 xs12 class="pt-0 pb-0">
              <v-card-text class="pt-0 pb-0">
                <v-layout row>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Mon"
                              color="red"
                              value="MON"
                              v-model="selectedEvent.days"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Tue"
                              color="red darken-3"
                              value="TUE"
                              v-model="selectedEvent.days"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Wed"
                              color="indigo"
                              value="WED"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Thu"
                              color="indigo darken-3"
                              value="THU"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Fri"
                              color="orange"
                              value="FRI"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Sat"
                              color="blue"
                              value="SAT"
                              v-model="selectedDays"
                  ></v-checkbox>
                  <v-checkbox class="mr-2 no-border pl-0 pt-0 mt-0"
                              label="Sun"
                              color="green"
                              value="SUN"
                              v-model="selectedDays"
                  ></v-checkbox>
                </v-layout>
              </v-card-text>
            </v-flex>

            <v-flex lg6 sm6 xs12 class="pt-0 pb-0" >
              <v-menu
                ref="dialog1"
                :close-on-content-click="false"
                v-model="birthday2"
                :return-value.sync="selectedEvent.date_from"
                lazy
                persistent
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="selectedEvent.date_from"
                  label="Start Date"
                  placeholder="dd/mm/yyyy"
                  solo
                  readonly
                  required
                ></v-text-field>
                <v-date-picker v-model="selectedEvent.date_from" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="birthday2 = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog1.save(selectedEvent.date_from)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex lg6 sm6 xs12 class="pt-0 pb-0">
              <v-menu
                ref="dialog"
                :close-on-content-click="false"
                v-model="birthday3"
                :return-value.sync="selectedEvent.date_to"
                lazy
                persistent
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="selectedEvent.date_to"
                  label="End Date"
                  placeholder="dd/mm/yyyy"
                  solo
                  readonly
                  required
                ></v-text-field>
                <v-date-picker v-model="selectedEvent.date_to" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="birthday3 = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.dialog.save(selectedEvent.date_to)">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>

        <!--<v-card-text>-->
        <!--<v-radio-group v-model="selectedEventClass" row>-->
        <!--<v-radio-->
        <!--label="Default"-->
        <!--color="blue"-->
        <!--value=""/>-->
        <!--<v-radio-->
        <!--label="Caution"-->
        <!--color="red"-->
        <!--value="event-item-caution"/>-->
        <!--<v-radio-->
        <!--label="Meeting"-->
        <!--color="green"-->
        <!--value="event-item-meeting"/>-->
        <!--<v-radio-->
        <!--label="Warning"-->
        <!--color="yellow"-->
        <!--value="event-item-warning"/>-->
        <!--<v-radio-->
        <!--label="Trip"-->
        <!--color="purple"-->
        <!--value="event-item-trip"/>-->
        <!--</v-radio-group>-->
        <!--</v-card-text>-->

        <v-card-actions class="mr-3">
          <v-spacer></v-spacer>

          <v-btn
            color="secondary"
            outline
            @click="dialogEditEvent = false">
            cancel
          </v-btn>

          <v-btn
            color="primary"
            @click="editEvent(selectedEvent.id)">
            Update
          </v-btn>

        </v-card-actions>

        <v-alert
          :value="true"
          type="error"
          v-if="eventCreateErrorMsg"
        >
          {{eventCreateErrorMsg}}
        </v-alert>
        <v-alert
          :value="true"
          type="success"
          v-if="eventCreationSuccessMsg"
        >
          {{eventCreationSuccessMsg}}
        </v-alert>
      </v-card>
    </v-dialog>
    <v-card class="card-r pt-2 pb-2 pl-2 pr-2">
      <full-calendar
        :events="events"
        locale="en"
        @eventClick="eventClick($event)"
        @dayClick="dayClick($event)"/>
    </v-card>
  </v-container>
</template>

<script>
  /* eslint-disable */
  import api from "@/utils/backend-api"
  export default {
    data () {
      return {
        row: null,
        dcfvrefds: "",
        dialog: false,
        dialog1: false,
        Class: {ClassType: "dsfdfd",},
        type: ["NoRepete", "Repete"],
        selectList: [],
        selectListLabel:'',
        dialogCreateEvent: false,
        dialogEditEvent: false,
        date1 : null,
        date : null,
        birthday3: false,
        birthday2: false,
        birthday1: false,
        birthday: false,
        classtype: null,
        classnae: null,
        workmunite: null,

        noOfStudents: null,
        class_location:null,
        selectedSlot: null,
        teacherType:'',
        SelectedInternalTeacher: null,
        SelectedExternalTeacher: null,
        exTeacherName:'',
        phonumber: null,
        emailad: null,

        createEventDate: null,
        selectedEventClass: null,
        selectedEvent: {
          days:[]
        },
        whats_app : ['Theory ', 'SnowClass'],
        time : ['theory ', 'practical'],
        workMin: ["60 min", "120 min" , "180 min", "240 min" ,"300 min", "360 min", "420 min", "480 min" ],
        timeslot: [
          {text:'00:00',value:'00:00'},
          {text:'00:30',value:'00:30'},
          {text:'01:00',value:'01:00'},
          {text:'01:30',value:'01:30'},
          {text:'02:00',value:'02:00'},
          {text:'02:30',value:'02:30'},
          {text:'03:00',value:'03:00'},
          {text:'03:30',value:'03:30'},
          {text:'04:00',value:'04:00'},
          {text:'04:30',value:'04:30'},
          {text:'05:00',value:'05:00'},
          {text:'05:30',value:'05:30'},
          {text:'06:00',value:'06:00'},
          {text:'06:30',value:'06:30'},
          {text:'07:00',value:'07:00'},
          {text:'07:30',value:'07:30'},
          {text:'08:00',value:'08:00'},
          {text:'08:30',value:'08:30'},
          {text:'09:00',value:'09:00'},
          {text:'09:30',value:'09:30'},
          {text:'10:00',value:'10:00'},
          {text:'10:30',value:'10:30'},
          {text:'11:00',value:'11:00'},
          {text:'11:30',value:'11:30'},
          {text:'12:00',value:'12:00'},
          {text:'12:30',value:'12:30'},
          {text:'13:00',value:'13:00'},
          {text:'13:30',value:'13:30'},
          {text:'14:00',value:'14:00'},
          {text:'14:30',value:'14:30'},
          {text:'15:00',value:'15:00'},
          {text:'15:30',value:'15:30'},
          {text:'16:00',value:'16:00'},
          {text:'16:30',value:'16:30'},
          {text:'17:00',value:'17:00'},
          {text:'17:30',value:'17:30'},
          {text:'18:00',value:'18:00'},
          {text:'18:30',value:'18:30'},
          {text:'19:00',value:'19:00'},
          {text:'19:30',value:'19:30'},
          {text:'20:00',value:'20:00'},
          {text:'20:30',value:'20:30'},
          {text:'21:00',value:'21:00'},
          {text:'21:30',value:'21:30'},
          {text:'22:00',value:'22:00'},
          {text:'22:30',value:'22:30'},
          {text:'23:00',value:'23:00'},
          {text:'23:30',value:'23:30'}
        ],
        timeslot1: [
          {text:'07:00 am',value:'07:00:00'},
          {text:'08:00 am',value:'08:00:00'},
          {text:'08:30 am',value:'08:30:00'},
          {text:'09:00 am',value:'09:00:00'},
          {text:'09:30 am',value:'09:30:00'},
          {text:'07:30 am',value:'07:30:00'},
          {text:'10:00 am',value:'10:00:00'},
          {text:'10:30 am',value:'10:30:00'},
          {text:'11:00 am',value:'11:00:00'},
          {text:'11:30 am',value:'11:30:00'},
          {text:'12:00 pm',value:'12:00:00'},
          {text:'12:30 pm',value:'12:30:00'},
          {text:'01:00 pm',value:'13:00:00'},
          {text:'01:30 pm',value:'13:30:00'},
          {text:'02:00 pm',value:'14:00:00'},
          {text:'02:30 pm',value:'14:30:00'},
          {text:'03:00 pm',value:'15:00:00'},
          {text:'03:30 pm',value:'15:30:00'},
          {text:'04:00 pm',value:'16:00:00'},
          {text:'04:30 pm',value:'16:30:00'},
          {text:'05:00 pm',value:'17:00:00'},
          {text:'05:30 pm',value:'17:30:00'},
          {text:'06:00 pm',value:'18:00:00'},
          {text:'06:30 pm',value:'18:30:00'},
        ],
        n_student : ['05 ', '10', '15', '20'],
        teacher : ['Saara ', 'Eman', 'Manoje', 'Kerlin'],
        classes : ['Class Title 1 ', 'Class Title 2 ', 'Class Title 3 ', 'Class Title 4 '],
        events:[],
        menu1:false,
        dateFormatted:'',
        ModulesList:[],
        TeacherList:[],
        InternalTeacherList:[],
        ExternalTeacherList:[],
        selectedClass:'',
        selectedDays:[],
        Intl:new Intl.DateTimeFormat('se'),
        eventCreateErrorMsg:'',
        eventCreationSuccessMsg:'',
        deletePopup:false,
        selectedDeleteOption:'',
        selectedDeleteEventId:'',
        repeatType:'',
        selectedFilter:'',
        LocationList:[],
        selectedFilter:'',
        selectedOption:{id:'all',name:'all'}
      }
    },
    created:function(){

      this.loadCalendarEvents()
      api.getData('admin/viewClubTypeModules')
        .then(res=>{
          this.ModulesList=res.data
        }).catch(err=>{
      })
      this.loadTeachers()
      this.loadLocationList()

    },
    watch:{
      selectedFilter:function(){
        switch(this.selectedFilter){
          case 'all':this.selectList=[];this.loadCalendarEvents();this.selectListLabel="All are listed"
            break;
          case 'Teachers':this.selectList=this.InternalTeacherList;this.selectListLabel="Choose teacher"
            break;
          case 'Classes':this.selectList=this.ModulesList;this.selectListLabel="Choose module"
            break;
          case 'Locations':this.selectList=this.LocationList;this.selectListLabel="Choose location"
            break;
        }
        console.log(this.selectList)
      }
    },
    methods: {
      loadLocationList(){
        let self=this
        api.postData('admin/viewClubCalenderLocation')
          .then(res=>{
            let LocationList=res.data
            let temp
            LocationList.forEach(val=>{
              temp={id:val,name:val}
              self.LocationList.push(temp)
            })


          }).catch(err=>{
            self.LocationList=[]
        })
      },
      loadTeachers(){
        let self=this
        api.postData('admin/teachers')
          .then(res=>{
            let TotalTeachersList=res.data
            TotalTeachersList.forEach(element=>{
              if(element.teacher_type=='internal'){
                self.InternalTeacherList.push(element)
              }else if(element.teacher_type=='external'){
                self.ExternalTeacherList.push(element)
              }
            })

          }).catch(err=>{

        })
      },
      loadEventDays(){
        let id=this.selectedEvent.id
        let self=this
        api.getData('admin/adminViewAClubCalendar/'+id)
          .then(res=>{
            // debugger
            console.log(res)
            self.selectedEvent.days=res.data.total_days
            self.selectedDays=res.data.total_days
          }).catch(err=>{

        })
      },
      eventClick($event) {
        const vm = this;
        // debugger
        vm.dialog = true;
        vm.selectedEvent = $event;
      },

      dayClick($event) {
        console.log("Hello")
        console.log($event)
        this.selectedDays=[]
        const vm = this;
        this.eventCreateErrorMsg=''
        this.eventCreationSuccessMsg=''

        this.selectedClass=''
        this.noOfStudents=''
        this.class_location=''
        this.selectedSlot=''
        this.teacherType=''
        this.SelectedInternalTeacher=''
        this.phonumber=''
        this.emailad=''
        this.selectedDays=[]
        this.date1=''
        this.date=''
        vm.dialogCreateEvent = true;


        vm.createEventDate = $event;
        console.log($event)
        // console.log(new Date($event).toISOString().substr(0, 10))
        // console.log(new Date(Date.parse($event)+330*60000))

        var event = new Date(Date.parse($event)+330*60000);
        // Korean uses year-month-day order and 05-hour time with AM/PM
        // console.log(event.toLocaleString('se', { timeZone: 'UTC' }));
        console.log(this.Intl.format(event));

        console.log($event);
        var options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        var formatter =  new Intl.DateTimeFormat('se', options);
        console.log(formatter.format($event));



        var y = $event.getFullYear();
        var m = $event.getMonth() + 1;
        var d = $event.getDate();
        vm.date1 = new Date(event).toISOString().substr(0, 10);
        vm.date = new Date(event).toISOString().substr(0, 10);
        // console.log(new Date(d+'-'+m+'-'+y))
        // vm.date1 = d+'-'+m+'-'+y;
        // vm.date="10-05-2019"
        // vm.date = new Date();
        // vm.date = $event;
      },

      createEvent() {
        this.eventCreateErrorMsg=''
        const vm = this;
        // vm.events.push({
        //   title: vm.teachername ? vm.teachername : 'Sample Event',
        //   classtype1: vm.classtype ? vm.classtype : 'Sample Event',
        //   classnae1: vm.classnae ? vm.classnae : 'Sample Event',
        //   nstudent1: vm.nstudent ? vm.nstudent : 'Sample Event',
        //   timeslo1: vm.timeslo ? vm.timeslo : 'Sample Event',
        //   workmunite1: vm.workmunite ? vm.workmunite : 'Sample Event',
        //   phonumber1: vm.phonumber ? vm.phonumber : 'Sample Event',
        //   emailad1: vm.emailad ? vm.emailad : 'Sample Event',
        //   start: vm.createEventDate,
        //   cssClass: vm.selectedEventClass ? vm.selectedEventClass : null
        // });

        // vm.createEventDate = null;
        // vm.teachername = '';
        // vm.classtype = '';
        // vm.classnae = '';
        // vm.nstudent = '';
        // vm.timeslo = '';
        // vm.workmunite = '';
        // vm.phonumber = '';
        // vm.emailad = '';
        // vm.dialogCreateEvent = false;
        let Data
        if(this.teacherType=='Internal'){
          Data={
            module_id:this.selectedClass,
            number_of_students:this.noOfStudents,
            class_location:this.class_location,
            teacher_id:this.SelectedInternalTeacher,
            time_from:this.selectedSlot,
            date_from:this.date1,
            date_to:this.date,
            day:this.selectedDays,
            // repeatType:this.repeatType
          }
        }else if(this.teacherType=='External'){
          Data={
            module_id:this.selectedClass,
            number_of_students:this.noOfStudents,
            class_location:this.class_location,
            teacher_id:this.SelectedExternalTeacher,
            time_from:this.selectedSlot,
            date_from:this.date1,
            date_to:this.date,
            day:this.selectedDays,
            // repeatType:this.repeatType
          }

        }else{
          // SelectedInternalTeacher
          if(this.exTeacherName && this.emailad && this.phonumber){
            this.eventCreateErrorMsg=""
          }else{
            this.eventCreateErrorMsg="Fill all fields and Try again"
          }
          Data={
            module_id:this.selectedClass,
            number_of_students:this.noOfStudents,
            class_location:this.class_location,
            teacher_name:this.exTeacherName,
            teacher_email:this.emailad,
            teacher_phone:this.phonumber,
            time_from:this.selectedSlot,
            date_from:this.date1,
            date_to:this.date,
            day:this.selectedDays,
            // repeatType:this.repeatType
          }
        }
        let self=this
        api.postData('admin/createClubCalender',Data)
          .then(res=>{
            if(res.status==201){
              self.loadCalendarEvents()
              this.eventCreationSuccessMsg='Event creation Successfully'
              setTimeout(()=>{
                self.dialogCreateEvent=false
              },1200);
            }else{
              this.eventCreateErrorMsg='Event creation failed'
            }
          }).catch(err=>{
          // debugger
          if(err.response.data.module_id){

          }else{
            let error=err.response.data.error.message
            this.eventCreateErrorMsg=error
          }
        })
      },
      editEvent(club_calendar_id) {
        this.eventCreateErrorMsg=''
        const vm = this;
        // vm.events.push({
        //   title: vm.teachername ? vm.teachername : 'Sample Event',
        //   classtype1: vm.classtype ? vm.classtype : 'Sample Event',
        //   classnae1: vm.classnae ? vm.classnae : 'Sample Event',
        //   nstudent1: vm.nstudent ? vm.nstudent : 'Sample Event',
        //   timeslo1: vm.timeslo ? vm.timeslo : 'Sample Event',
        //   workmunite1: vm.workmunite ? vm.workmunite : 'Sample Event',
        //   phonumber1: vm.phonumber ? vm.phonumber : 'Sample Event',
        //   emailad1: vm.emailad ? vm.emailad : 'Sample Event',
        //   start: vm.createEventDate,
        //   cssClass: vm.selectedEventClass ? vm.selectedEventClass : null
        // });

        // vm.createEventDate = null;
        // vm.teachername = '';
        // vm.classtype = '';
        // vm.classnae = '';
        // vm.nstudent = '';
        // vm.timeslo = '';
        // vm.workmunite = '';
        // vm.phonumber = '';
        // vm.emailad = '';
        // vm.dialogCreateEvent = false;
        let Data
        if(this.selectedEvent.TeacherType=='Internal' || this.selectedEvent.TeacherType=='External'){
          Data={
            module_id:this.selectedEvent.module_id,
            number_of_students:this.selectedEvent.number_of_students,
            class_location:this.selectedEvent.class_location,
            teacher_id:this.selectedEvent.teacherId,
            time_from:(this.selectedEvent.time_from).substring(0,5),
            date_from:this.selectedEvent.date_from,
            date_to:this.selectedEvent.date_to,
            day:this.selectedDays,
            club_calendar_id:club_calendar_id
          }
        }else if(this.selectedEvent.TeacherType=='Add New External'){
          if(this.selectedEvent.teacherName && this.selectedEvent.teacherMail && this.selectedEvent.teacherMail){
            this.eventCreateErrorMsg=""
          }else{
            this.eventCreateErrorMsg="Fill all fields and Try again"
          }
          Data={
            module_id:this.selectedEvent.module_id,
            number_of_students:this.selectedEvent.number_of_students,
            class_location:this.selectedEvent.class_location,
            teacher_name:this.selectedEvent.teacherName,
            teacher_email:this.selectedEvent.teacherMail,
            teacher_phone:this.selectedEvent.teacherPhone,
            time_from:(this.selectedEvent.time_from).substring(0,5),
            date_from:this.selectedEvent.date_from,
            date_to:this.selectedEvent.date_to,
            day:this.selectedDays,
            club_calendar_id:club_calendar_id
          }

        }
        let self=this

        if(!this.eventCreateErrorMsg){
          api.postData('admin/updateAClubCalender',Data)
            .then(res=>{
              if(res.status==201){
                self.loadCalendarEvents()
                // self.eventCreationSuccessMsg=res.data.status
                self.eventCreationSuccessMsg="Successfully Updated"
                self.loadTeachers()
                setTimeout(()=>{
                  this.dialogEditEvent=false
                },1200);
              }
              // else{
              //   self.eventCreateErrorMsg='Event creation failed'
              // }
            }).catch(err=>{
            // debugger
            let error=err.response.data.error.message
            self.eventCreateErrorMsg=error
          })
        }
      },
      showDeletePopup(eventId){
        this.selectedDeleteEventId=eventId
        this.deletePopup=true
        this.dialog=false
      },

      deleteEvent(eventId){
        let self=this
        if(this.selectedDeleteOption=='all'){
          api.postData('admin/deleteClubCalender',{club_calendar_id:eventId})
            .then(res=>{
              self.loadCalendarEvents()
              self.deletePopup=false
            }).catch(err=>{

            //delete below lines after
            self.loadCalendarEvents()
            self.deletePopup=false
          })
        }else if(this.selectedDeleteOption=='single'){
          let IdArray=[]
          IdArray.push(eventId)
          api.postData('admin/deleteAClubCalender',{club_calendar_id:IdArray})
            .then(res=>{
              self.loadCalendarEvents()
              self.deletePopup=false
            }).catch(err=>{
            //delete below lines after
            self.loadCalendarEvents()
            self.deletePopup=false
          })
        }
      },
      loadCalendarEvents(){
        let self=this
        let formData=new FormData()
        switch(this.selectedFilter){
          case 'Teachers':formData.append('teacher_id',this.selectedOption);
                          break;
          case 'Classes':formData.append('module_id',this.selectedOption);
                          break;
          case 'Locations':formData.append('class_location',this.selectedOption);
                          break;
        }
        api.postData('admin/viewAllClubCalender',formData)
          .then(res=>{
            // debugger
            let events=res.data
            events.forEach((element)=>{
              let ev={
                id:element.id,
                title : element.class_title,
                module_id: parseInt(element.module_id),
                start : element.date,
                end : element.date,
                date_from:element.date_from,
                date_to:element.date_to,
                location:element.class_location,
                description:element.class_description,
                number_of_students:element.number_of_students,
                class_location:element.class_location,
                time_from:element.time_from,
                time_to:element.time_to,
                hours:element.hours,

                cssClass : 'event-item-meeting',
                days:[]
              }

              let ev1
              if(element.teacher){
                ev1={
                  teacherId:parseInt(element.teacher_id),
                  teacherName:element.teacher.name,
                  teacherPhone:element.teacher.phone,
                  teacherMail:element.teacher.email,
                  TeacherType:element.teacher_type,
                }
              }
              let finalEv={...ev,...ev1}
              events.push(finalEv)
            })

            self.events=events

          }).catch(err=>{
          self.events=[]
        })
      }
    }
  }
</script>

<style>
  .full-calendar-header .header-center {
    flex: unset;
    margin-bottom: 7px;
  }
  .full-calendar-header .header-center .title {
    padding: 2px 10px;
  }
  .prev-month,.next-month {
    font-size: 16px !important;
    font-weight: bold;
    background: #005091;
    color: #ffffff;
    padding: 2px 25px;
    border-radius: 5px;
  }
  .full-calendar-header .header-center .title{
    margin: 0px !important;
  }
  .t-radio .v-input .v-input__control .v-input__slot{
    color: #ffffff !important;
    margin-bottom: 0px;
  }
  .t-radio .v-input .v-input__control .v-messages{
    display: none!important;
  }
  /*.t-radio .v-input .v-input__control .v-input__slot .v-text-field__details{*/
    /*display: none!important;*/
  /*}*/
  .comp-full-calendar {
    padding: 0px;
    background: transparent;
    max-width: unset!important;
  }
  .full-calendar-body .dates .week-row .day-cell{
    /*min-height: 60px;*/
    min-height: 70px!important;
  }
  .full-calendar-body .dates .dates-events .events-week .events-day{
    min-height: 50px!important;
    /*min-height: 40px;*/
  }
  .full-calendar-body .dates .dates-events .events-week{
    height: 68px!important;

  }
  .full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item.is-end {
    margin-right: 20px!important;
    margin-bottom: 0px;
    margin-top: -10px;

  }
  .full-calendar-body .dates .dates-events .events-week .events-day .day-number {
    text-align: right;
    padding: 0px;


  }
  .full-calendar-body p {
    margin-bottom: 0px;
  }
  .full-calendar-body {
    margin-top: 0px;
  }
  #calendar {
    height: 100%;
  }

  .prev-month {
    font-size: 16px !important;
    font-weight: bold;
  }

  .next-month {
    font-size: 16px !important;
    font-weight: bold;
  }

  .event-item {
    font-family: 'Gill Sans', 'Gill Sans MT', 'Trebuchet MS', sans-serif !important;
    font-size: 10px !important;
  }

  .event-item-caution {
    background-color: #e89a9a !important;
  }

  .event-item-warning {
    background-color: #ffffa5 !important;
  }

  .event-item-meeting {
    background-color: #71d48e !important;
  }

  .event-item-trip {
    background-color: #8d78e6 !important;
  }

</style>






<!--<template>-->
<!--<v-app id="dayspan" v-cloak>-->
<!--<ds-calendar-app class="calendsder" :calendar="calendar"></ds-calendar-app>-->
<!--</v-app>-->
<!--</template>-->
<!--<script>-->
<!--import { Calendar } from 'dayspan'-->

<!--export default {-->
<!--name: 'app',-->
<!--data: () => ({-->
<!--calendar: Calendar.months(),-->
<!--sideNav: false-->
<!--})-->
<!--}-->
<!--</script>-->

<!--<style lang="stylus">-->
<!--/*.calendsder .v-toolbar__content>:first-child, .v-toolbar__extension>:first-child{*/-->
<!--/*display: none!important;*/-->
<!--/*}*/-->
<!--.calendsder .v-navigation-drawer&#45;&#45;close.v-navigation-drawer&#45;&#45;temporary {-->
<!--transform: translateX(-13vw) !important;-->
<!--}-->
<!--.v-navigation-drawer[data-booted=true]{-->
<!--display: none!important;-->
<!--}-->
<!--/*.calendsder .v-content .ds-expand{*/-->
<!--/*padding: 0px!important;*/-->
<!--/*}*/-->
<!--/*.ds-app-calendar-toolbar.v-content{*/-->
<!--/*padding: 0px !important;*/-->
<!--/*}*/-->
<!--.ds-app-calendar-toolbar{-->
<!--position: relative !important;-->
<!--z-index: 1;-->
<!--}-->
<!--.calender.v-navigation-drawer{-->
<!--left: unset!important;-->
<!--margin-top:180px!important;-->

<!--}-->
<!--.v-content.ds-expand{-->

<!--}-->

<!--.calender .v-navigation-drawer{-->
<!--position: unset!important;-->
<!--display: none!important;-->
<!--}-->

<!--.v-toolbar__side-icon .v-btn .v-btn&#45;&#45;icon .theme&#45;&#45;light{-->
<!--display: none!important;-->
<!--}-->
<!--/*.v-content{*/-->
<!--/*padding: 0px !important;*/-->
<!--/*}*/-->
<!--.v-navigation-drawer&#45;&#45;fixed{-->
<!--position: relative!important;-->
<!--}-->
<!--</style>-->
<!--&lt;!&ndash;<template>&ndash;&gt;-->
<!--&lt;!&ndash;<div>&ndash;&gt;-->
<!--&lt;!&ndash;&lt;!&ndash;<MainCalender/>&ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->
<!--&lt;!&ndash;</template>&ndash;&gt;-->
<!--&lt;!&ndash;<script>&ndash;&gt;-->
<!--&lt;!&ndash;/* eslint-disable */&ndash;&gt;-->
<!--&lt;!&ndash;// import MainCalender from "../.././calender/maincalender/MainCalender";&ndash;&gt;-->
<!--&lt;!&ndash;export default {&ndash;&gt;-->
<!--&lt;!&ndash;data () {&ndash;&gt;-->
<!--&lt;!&ndash;return {}&ndash;&gt;-->
<!--&lt;!&ndash;},&ndash;&gt;-->
<!--&lt;!&ndash;components: {&ndash;&gt;-->
<!--&lt;!&ndash;// MainCalender&ndash;&gt;-->
<!--&lt;!&ndash;}&ndash;&gt;-->
<!--&lt;!&ndash;}&ndash;&gt;-->
<!--&lt;!&ndash;</script>&ndash;&gt;-->

<!--&lt;!&ndash;<style>&ndash;&gt;-->
<!--&lt;!&ndash;</style>&ndash;&gt;-->



// WEBPACK FOOTER //
// src/components/pages/AdminCalender.vue